export default "__VITE_ASSET__CkuaIGvH__"